module.exports = __webpack_public_path__ + "static/media/visa.39a1fc64.svg";